import Vue from "vue";
import VueRouter from "vue-router";
import Editor from "../views/Editor.vue";
import Preview from "../views/Preview.vue";
import Iframe from "../views/Iframe.vue";
import Account from "../views/Account.vue";
import SignIn from "../views/SignIn.vue";
import Dashboard from "../views/Dashboard.vue";
//import Users from "../views/Users/Users.vue";
import formManager from "../views/formManager/formManager.vue";
import formManager2 from "../views/formManager2/formManager2.vue";
import Forms from "../views/Forms/Forms";
import Widgets from "../views/Widgets/Widgets";
import WidgetEditor from "../views/Widgets/WidgetEditor";
import WidgetView from "../views/Widgets/View";
import SubmittedForm from "../views/SubmittedForm";
import Submits from "../views/Submits/Submits";
import UsersEdit from "../components/UsersEdit";
import Password from "../components/Password";
import safeLocalStorage from "../utils/localstorage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    meta: {
      title: "Dashboard",
      requiresAuth: true
    },
    component: Dashboard
  },
  {
    path: "/forms",
    name: "Forms",
    meta: {
      title: "Forms",
      requiresAuth: true
    },
    component: Forms
  },
  {
    path: "/search",
    name: "Search",
    meta: {
      title: "Search",
      requiresAuth: true
    },
    component: Forms
  },
  {
    path: "/submits",
    name: "Submits",
    meta: {
      title: "Submits",
      requiresAuth: true
    },
    component: Submits
  },
  {
    path: "/widgets",
    name: "Widgets",
    meta: {
      title: "Widgets",
      requiresAuth: true
    },
    component: Widgets
  },
  {
    path: "/formManager",
    name: "formManager",
    meta: {
      title: "formManager",
      requiresAuth: true
    },
    component: formManager
  },
  {
    path: "/formManager2",
    name: "formManager2",
    meta: {
      title: "formManager2",
      requiresAuth: true
    },
    component: formManager2
  },
  {
    path: "/widget-editor/:id?",
    name: "Widget-editor",
    meta: {
      title: "Widget Editor",
      requiresAuth: true
    },
    component: WidgetEditor
  },
  {
    path: "/widgets/view/:id?",
    name: "Widgets-view",
    meta: {
      title: "View",
      requiresAuth: true
    },
    component: WidgetView
  },
  {
    path: "/editor/:id?",
    name: "Editor",
    meta: {
      title: "Editor",
      requiresAuth: true
    },
    component: Editor
  },
  {
    path: "/preview/:id?",
    name: "Preview",
    meta: {
      title: "Preview",
      requiresAuth: true
    },
    component: Preview
  },
  {
    path: "/submittedform/:submitid?",
    name: "SubmittedForm",
    meta: {
      title: "SubmittedForm",
      requiresAuth: true
    },
    component: SubmittedForm,
    props: () => {
      return {
        isValidSubmit: false
      };
    }
  },

  {
    path: "/iframe/:id/:submitid",
    name: "Iframe",
    meta: {
      requiresAuth: true
    },
    component: SubmittedForm,
    props: () => {
      return {
        isValidSubmit: true
      };
    }
  },

  {
    path: "/iframe/:id",
    name: "Iframe",
    meta: {
    },
    component: Iframe,
    props: route => {
      return {
        clientID: route.query.clientID,
        initialVal: [
          {
            name: "widgets[address][zipcode]",
            value: route.query.zipcode
          },
          {
            name: "widgets[address][number]",
            value: route.query.number
          },
          {
            name: "widgets[address][number_addition]",
            value: route.query.number_adt
          },
          {
            name: "consumption[status]",
            value: route.query.household ? "2" : "1"
          },
          {
            name: "consumption[family_situation]",
            value: route.query.household
          },
          {
            name: "widgets[address][city]",
            value: route.query.city
          },
          {
            name: "widgets[address][street]",
            value: route.query.street
          },
          {
            name: "widgets[personaldata][initials]",
            value: route.query.initials
          },
          {
            name: "widgets[personaldata][firstname]",
            value: route.query.firstname
          },
          {
            name: "widgets[personaldata][lastname]",
            value: route.query.lastname
          },
          {
            name: "widgets[personaldata][date_of_birth]",
            value: route.query.date_of_birth
          },
          {
            name: "widgets[personaldata][email]",
            value: route.query.email
          },
          {
            name: "widgets[personaldata][phone]",
            value: route.query.phone
          },
          {
            name: "widgets[personaldata][phone2]",
            value: route.query.phone2
          },
          {
            name: "widgets[personaldata][iban]",
            value: route.query.iban
          },
          {
            name: "widgets[personaldata][nationality]",
            value: route.query.nationality
          },
          {
            name: "widgets[personaldata][bedrijfsnaam]",
            value: route.query.company_name
          },
          {
            name: "widgets[personaldata][kvk]",
            value: route.query.kvk
          },
          {
            name: "widgets[personaldata][prefix]",
            value: route.query.prefix
          },
          {
            name: "extra[redirect]",
            value: route.query.redirect
          }
        ]
      };
    }
  },
  {
    path: "/sign-in",
    name: "SignIn",
    meta: {
      title: "Sign In",
      guest: true,
      requiresAuth: false
    },
    component: SignIn
  },
  // {
  //   path: "/users",
  //   name: "Users",
  //   meta: {
  //     title: "Users",
  //     requiresAuth: true
  //   },
  //   component: Users
  // },
  {
    path: "/user/:id",
    name: "UsersEdit",
    meta: {
      title: "UsersEdit",
      requiresAuth: true
    },
    component: UsersEdit
  },
  {
    path: "/account",
    name: "Account",
    meta: {
      title: "Account",
      requiresAuth: true
    },
    component: Account
  },
  {
    path: "/password",
    name: "Password",
    meta: {
      title: "Password",
      requiresAuth: false
    },
    component: Password
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (safeLocalStorage.getItem("arx.token") == null) {
      next({
        path: "/sign-in",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (safeLocalStorage.getItem("arx.token") == null) {
      next();
    } else {
      next({
        path: "/",
        params: { nextUrl: to.fullPath }
      });
    }
  } else {
    next();
  }
});

export default router;
